import React from "react";
import { FaJediOrder } from "react-icons/fa";
import "./Marquee.scss";
import gsap from "gsap";

const Marquee = () => {

  return (
    <section className="marquee">
      <div className="marquee-content scroll">
        <h5>JOIN US!</h5>
        <FaJediOrder/>
        <h5>JOIN US!</h5>
        <FaJediOrder/>
        <h5>JOIN US!</h5>
        <FaJediOrder/>
      </div>
      <div className="marquee-content scroll">
        <h5>JOIN US!</h5>
        <FaJediOrder/>
        <h5>JOIN US!</h5>
        <FaJediOrder/>
        <h5>JOIN US!</h5>
        <FaJediOrder/>
      </div>
    </section>
  );
};

export default Marquee;
